import { env } from './env';

// a reported voice note, played from the copy kept aside when it was reported (Messages and Gist)
export function ReportedVoice({ path }: { path: string }) {
  return <audio controls preload="none" aria-label="Reported voice note" src={`${env.apiOrigin}${path}`} />;
}
